import { render, staticRenderFns } from "./T1PotwierdzenieContentError.vue?vue&type=template&id=7f5cd484&"
import script from "./T1PotwierdzenieContentError.vue?vue&type=script&lang=js&"
export * from "./T1PotwierdzenieContentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports